import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Notification, networkNotification } from '../../entities/entities';
import { LoggingService, NotifyService } from '../../services/services';

@Component({
  selector: 'app-settings-attributes',
  templateUrl: './settings-attributes.component.html',
  styleUrls: ['./settings-attributes.component.css'],
})
export class SettingsAttributesComponent implements OnInit, OnDestroy {
  isWorking: boolean;
  isError: boolean;
  isSuccess: boolean;
  private sub: any;
  private currentReportIndex: number;

  constructor(
    private loggingService: LoggingService,
    private notifyService: NotifyService,
    private route: ActivatedRoute,
    private router: Router
  ) {

    if (loggingService) {
      loggingService.logPageView('Settings-Attributes');
    }
  }

  ngOnInit() {

  }

  ngOnDestroy() {

    if (this.sub) {
      this.sub.unsubscribe();
    }

  }
}



// WEBPACK FOOTER //
// D:/a/1/s/src/app/components/settings-attributes/settings-attributes.component.ts